<form #formBagPickupLocationEdit="ngForm" id="confirmAddress" name="formBagPickupLocationEdit"
  (submit)="handleSubmitLocation($event)" novalidate>
  <div class="form-group form-group-lg">
    <app-location-hotel-business-lookup [selectedLocationType]="selectedLocationType"
      [placeholder]="addressLookupPlaceholder" [appCopy]="appCopy" [selectedLanguage]="selectedLanguage"
      [selectedAddress]="locationData" [errorSubmitEmpty]="errorSubmitEmpty" [errorNoPostcode]="errorNoPostcode"
      [errorPostcodeOutsideZone]="errorPostcodeOutsideZone" (changedAddressLine)="changedAddressLine($event)"
      (selectedLocation)="getChildLocation($event)" (clearInput)="clearInput($event)"
      (toggleShowMenu)="toggleShowMenu($event)" [bookingType]="bookingType">
    </app-location-hotel-business-lookup>
  </div>

  <div class="panel panel-default" *ngIf="locationData.geoCoord">
    <div class="row fadeIn">
      <div class="col-sm-6">
        <img [src]="mapImgUrl" alt="Location Map" />
      </div>
      <div class="col-sm-6">
        <div class="panel-body">
          <h4 class="margin-top-0 margin-bottom-16">{{locationData.name}}</h4>
          <p class="text-muted margin-bottom-0">
            <span *ngIf="locationData.addressLine1 || locationData.addressLine2">
              {{locationData.addressLine1}} {{locationData.addressLine2}}<br>
            </span>
            {{locationData.addressPostCode}}<br>
            {{locationData.addressTown}} <br>
            {{locationData.addressCountry}}
          </p>
        </div>
      </div>
    </div>
  </div>

  <app-subsidy *ngIf="isSbbSubsidyApplicable || isSbbSubsidyApplied || isDbSubsidyApplicable || isDbSubsidyApplied || isCatDiscountApplicable"
    [appCopy]="appCopy" [appAirportCopy]="appAirportCopy"
    [selectedLanguage]="selectedLanguage"
    [isSbbSubsidyApplicable]="isSbbSubsidyApplicable" [isDbSubsidyApplicable]="isDbSubsidyApplicable"
    [isCatDiscountApplicable]="isCatDiscountApplicable">
  </app-subsidy>

  <div class="address-info">
    <div *ngIf="!isLoading" [ngStyle]="{marginTop: '30px'}" class="alert alert-success flex-always">
      <i class="icon">info</i>
      <div>
        <p [innerHtml]="appCopy.panelHeader['addressInfoText'+selectedLanguage]"></p>
      </div>
    </div>
  </div>

  <button id="formBagPickupLocationEdit-submit" type="submit" [disabled]="errorPostcodeOutsideZone || isLoading || virtualBagsCount === 0 || virtualBagsCount > 25"
    class="btn btn-purple btn-block margin-top-32 margin-bottom-32" *ngIf="locationData.addressPostCode !== ''">

    <div class="loader-container-btn" *ngIf="isLoading">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{appCopy.panelHeader['buttonContinue'+selectedLanguage]}}
  </button>

</form>
